module.exports = __webpack_public_path__ + "img/design-1.3d9efea6.png";